import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import DevisPage, { QuestionnairePage } from "./pages/DevisPage";
import ServicesPage from "./pages/ServicesPage";
import MaisonPage from "./pages/MaisonPage";
import UniversePage from "./pages/UniversePage";
import RealisationsPage from "./pages/RealisationsPage";
import ContactPage from "./pages/ContactPage";
import { ContentProvider } from "./lib/siteContent";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import FAQ from "./pages/legal/FAQ";
import ProjectPage from "./pages/ProjectPage";
import Conditions from "./pages/legal/Conditions";
import Mentions from "./pages/legal/Mentions";
import Privacy from "./pages/legal/Privacy";
import { AuthProvider, useAuth } from "./lib/auth";

const PAGE_TITLES = {
  '/': 'JBMH Events | Maison événementielle',
  '/la-maison': 'La Maison | JBMH Events',
  '/univers/weddings': 'Weddings | JBMH Events',
  '/univers/receptions-corporate': 'Réceptions privées & Corporate | JBMH Events',
  '/univers/heritage': 'JBMH Héritage | JBMH Events',
  '/devis': 'Demander un devis | JBMH Events',
  '/devis/weddings': 'Confiez-nous votre mariage | JBMH Events',
  '/devis/receptions': 'Donnons forme à votre réception | JBMH Events',
  '/devis/heritage': 'Célébrons votre héritage | JBMH Events',
  '/realisations': 'Réalisations | JBMH Events',
  '/contact': 'Contact | JBMH Events',
  '/services': 'Nos services | JBMH Events',
  '/faq': 'FAQ | JBMH Events',
  '/conditions': 'Conditions | JBMH Events',
  '/mentions-legales': 'Mentions légales | JBMH Events',
  '/confidentialite': 'Politique de confidentialité | JBMH Events',
};

const PageTitle = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (pathname === '/' && hash === '#gallery') document.title = 'Réalisations | JBMH Events';
    else if (pathname.startsWith('/admin')) document.title = 'Administration | JBMH Events';
    else document.title = PAGE_TITLES[pathname] || 'JBMH Events';
  }, [pathname, hash]);
  return null;
};

const ProtectedAdmin = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFFFFF] text-[#111111] text-xs uppercase tracking-[0.4em]">
        Chargement…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
          <PageTitle />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/devis" element={<DevisPage />} />
            <Route path="/devis/:slug" element={<QuestionnairePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/la-maison" element={<MaisonPage />} />
            <Route path="/univers/:slug" element={<UniversePage />} />
            <Route path="/realisations" element={<RealisationsPage />} />
            <Route path="/realisations/:slug" element={<ProjectPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/conditions" element={<Conditions />} />
            <Route path="/mentions-legales" element={<Mentions />} />
            <Route path="/confidentialite" element={<Privacy />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedAdmin>
                  <AdminDashboard />
                </ProtectedAdmin>
              }
            />
          </Routes>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
